import styled from 'styled-components';

export const SignInWrap = styled.section``;
